import React, { useEffect, useCallback, useContext } from "react";
import { useDropzone } from "react-dropzone";
import { ModelContext } from "../contexts/ModelContext";

function PdfUpload({ setPdf, disabled }) {
  const {setChangeData} = useContext(ModelContext)

  const onDrop = useCallback((acceptedFiles) => {
    setChangeData(true)
    if (
      acceptedFiles.length !== 1 ||
      acceptedFiles[0].type !== "application/pdf"
    ) {
      alert("請選擇PDF檔案還有檔案太多了");
      return;
    }
  }, []);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    maxFiles: 1,
    disabled: disabled,
  });

  useEffect(() => {
    setPdf(acceptedFiles);
  }, [acceptedFiles]);

  const files = acceptedFiles.map((file) => (
    <li
      key={file.path}
      style={{
        display: "flex",
        alignItems: "flex-start",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px 24px",
        background: "#fff",
        position: "relative",
        margin: "4px",
      }}
    >
      <div>{file.name}</div>
    </li>
  ));
  return (
    <section
    style={{
      border: "1px solid #818181",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      background: "#F0FBFF",
      padding: "8px",
    }}
    >
      <div {...getRootProps()} style={{ padding: "16px 0px" }}>
        <input {...getInputProps()} />
        <p style={{ cursor: "pointer" }}>拖拉檔案到此，或點此選擇檔案</p>
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </section>
  );
}

export default PdfUpload;
